module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p1-B-f01a42082a1a57a3c41305f078eec4ca.png";